export enum NotifyEmail {
	HARDSHIP = 'info@arlcollect.com',
	COMPLAINT = 'complaints@arlcollect.com',
}
